import React, { useEffect, useState, forwardRef } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../Components/formElements/InputField";
import { getTodayDate } from "../../../../common/Validations";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  getEquipmentRentFormList,
  getMRUserList,
} from "../../../../redux/feature/customer_app/customerSlice";

// import { getSupplierList } from "../../../../redux/feature/supplier_app/supplierSlice";
import ItemService from "../../../../services/customer_appCommonService";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { serviceAssignentCategoryOption } from "./constants";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import DataTable from "react-data-table-component";

// ── Utility: ISO UTC string → IST display ──────────────────────────────────
const formatIST = (isoString) => {
  if (!isoString) return { date: "--", time: "" };
  const d = new Date(isoString);
  const date = d.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const time = d.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return { date, time };
};

const AssignToDispatchModel = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const { show, onHide, erfData, onSuccess } = props;

  //eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  let mrUserData = useSelector((state) => state?.customer?.mrUserList);
  const [selectedServiceExecutiveData, setSelectedServiceExecutiveData] =
    useState({});

  const [getDropdownData, setDropdownData] = useState("");
  const [validation, setValidation] = useState({});

  useEffect(() => {
    if (show) {
      const payload = {
        page: 1,
        per_page: 999,
        queryName: "get_ServiceProvider_list",
        searchTerm: "",
        timeZone: "Asia/Calcutta",
      };
      dispatch(getMRUserList(payload));
    }
  }, [show, dispatch]);

  useEffect(() => {
    if (!show) {
      setSelectedSupplier("");
      setSelectedServiceExecutiveData({});
      setFormInputs({});
      setValidation({});
      setShouldCollectMoney(false);
    }
  }, [show]);

  const handleSupplierChange = (e) => {
    const value = e.target.value;
    setSelectedSupplier(value);

    const selected = mrUserData?.data?.find((item) => item.userId === value);

    if (selected) {
      setSelectedServiceExecutiveData(selected);
    }
  };
  //eslint-disable-next-line
  const [dispatchHeader, setDispatchHeader] = useState({
    truckNo: "",
    driverName: "",
    contactNumber: "",
    dispatchAddress: "",
    addressPincode: "",
    dispatchTime: getCurrentTime(),
    dispatchDate: getTodayDate(""),
    dispatchVehicle: "",
    erfDispatchRemark: "",
    erfDispatchDateAndTime: "",
    ewayBillDate: "",
    ewayBillNo: "",
  });

  useEffect(() => {
    // 1. Process rentItems ONLY if the array has items in it
    if (erfData?.rentItems?.length > 0) {
    }

    // 2. Process saleItems independently ONLY if the array has items in it
    if (erfData?.saleItems?.length > 0) {
    }
  }, [erfData]);

  useEffect(() => {
    if (erfData && show) {
      // Auto-fill dispatch address from delivery address
      setDispatchHeader((prev) => ({
        ...prev,
        dispatchAddress: erfData?.deliveryAddress || "",
        addressPincode: erfData?.deliveryPinCode || "",
      }));
    }
  }, [erfData, show]);

  let userData = useSelector((state) => state?.user); // User Details from Store

  // --- 1. ROLE IDENTIFICATION ---
  // const isSalesPerson = useMemo(() => {
  //   return (
  //     userData?.data?.roles?.some((r) => r.roleId === "SALES-OFFICER") || false
  //   );
  // }, [userData]);

  // const isStorePerson = useMemo(() => {
  //   return userData?.data?.roles?.some((r) => r.roleId === "STORE") || false;
  // }, [userData]);

  // Handle row input change

  const [isDispatchVisible, setIsDispatchVisible] = useState(true);
  const [
    isServiceExecutiveHistoryVisible,
    setIsServiceExecutiveHistoryVisible,
  ] = useState(true);

  const toggleCardVisibility1 = () => {
    setIsDispatchVisible(!isDispatchVisible);
  };

  const toggleCardVisibility2 = () => {
    setIsServiceExecutiveHistoryVisible(!isServiceExecutiveHistoryVisible);
  };

  function getCurrentTime() {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  }

  useEffect(() => {
    if (!getDropdownData) return;
    if (getDropdownData?.textField === "serviceAssignCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // setAssignCategory(getDropdownData.name);
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //eslint-disable-next-line
  const [formInputs, setFormInputs] = useState({});
  const [shouldCollectMoney, setShouldCollectMoney] = useState(false);
// eslint-disable-next-line
  const fetchData = async (page = 1, size = 10, search = "") => {
    setLoading(true);
    try {
      const payload = {
        queryName: "RTDERF",
        page,
        per_page: size,
        searchTerm: search,
        timeZone: "Asia/Calcutta",
        rowFilter: {},
      };

      let statusFilter = null;

      if (statusFilter) {
        payload.rowFilter = {
          $and: [{ status: { $in: statusFilter } }],
        };
      }

      await dispatch(getEquipmentRentFormList(payload));
    } catch (error) {
      console.error("Error fetching list", error);
      toast.error("Error loading records");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = ({ target: { name, value } }) => {
    const errors = {};

    setFormInputs((prev) => ({ ...prev, [name]: value }));

    setValidation((prev) => ({ ...prev, [name]: errors[name] || "" }));
  };

  const assignmentHistoryColumns = [
    {
      name: "Assigned Date",
      selector: (row) => row?.assignDateAndTime || "--",
      cell: (row) => {
        const { date, time } = formatIST(row?.assignDateAndTime);
        return (
          <div>
            <p className="m-0 fw-medium">{date}</p>
            <p className="m-0 text-muted" style={{ fontSize: "11px" }}>
              {time}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Executive",
      selector: (row) => row?.serviceProviderName || "--",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row?.serviceProviderName || "--"}</p>
          <p className="m-0 text-muted" style={{ fontSize: "11px" }}>
            {row?.serviceProviderCode || ""}
          </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      selector: (row) => row?.serviceAssignCategory || "--",
      cell: (row) => (
        <span className="text-dark">{row?.serviceAssignCategory || "--"}</span>
      ),
      width: "150px",
    },
    {
      name: "Description",
      selector: (row) => row?.serviceAssignCategoryDescription || "--",
      cell: (row) => <p>{row?.serviceAssignCategoryDescription || "--"}</p>,
      sortable: true,
      width: "250px",
    },
    {
      name: "Assigned By",
      selector: (row) => row?.assignedBy || "--",
      cell: (row) => (
        <span className="fw-medium">{row?.assignedBy || "--"}</span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Collect Money",
      selector: (row) => row?.shouldCollectMoney,
      cell: (row) => (
        <span
          className={
            row?.shouldCollectMoney ? "text-success fw-bold" : "text-muted"
          }
        >
          {row?.shouldCollectMoney ? "Yes" : "No"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "Job Status",
      cell: (row) => {
        const status = row?.jobStatus || "Pending";
        const badgeColor =
          status === "Done"
            ? "#28a745"
            : status === "Not Done"
              ? "#dc3545"
              : "#ffc107";
        return (
          <span
            className="badge"
            style={{
              backgroundColor: badgeColor,
              color: status === "Pending" ? "black" : "white",
              padding: "6px 10px",
              borderRadius: "10px",
            }}
          >
            {status}
          </span>
        );
      },
      width: "130px",
    },
    {
      name: "Remarks",
      selector: (row) => row?.jobStatusRemarks || "--",
      width: "200px",
    },
  ];

  const handleUpdate = async () => {
    if (erfData?.jobDoneStatus === "Pending") {
      toast.error(
        "Current Service Executive's job is still pending. Cannot re-assign until marked as Done or Not Done.",
      );
      return;
    }

    // Validation
    if (!selectedServiceExecutiveData?.userId) {
      toast.error("Please select a Service Executive");
      return;
    }
    if (!formInputs.serviceAssignCategory) {
      toast.error("Please select an Assignment Category");
      return;
    }
    if (!formInputs.serviceAssignCategoryDescription) {
      toast.error("Please select an Assignment Description");
      return;
    }

    try {
      const assignTimestamp = new Date().toISOString();

      const newAssignmentEntry = {
        serviceProviderCode:
          selectedServiceExecutiveData?.userId || selectedSupplier,
        serviceProviderUserId:
          selectedServiceExecutiveData?.userId || selectedSupplier,
        serviceProviderName:
          selectedServiceExecutiveData?.firstName ||
          selectedServiceExecutiveData?.name ||
          "",
        serviceAssignCategory: formInputs.serviceAssignCategory,
        serviceAssignCategoryCode: formInputs.serviceAssignCategoryCode,
        serviceAssignCategoryDescription:
          formInputs.serviceAssignCategoryDescription,
        assignDateAndTime: assignTimestamp,
        assignedBy: userData?.data?.userId,

        shouldCollectMoney: shouldCollectMoney,

        jobStatus: "Pending",
        jobStatusRemarks: "",
      };

      const existingHistory = erfData?.assignedServiceExecutives || [];

      const updatedHistory = [...existingHistory, newAssignmentEntry];

      const payloadData = {
        ...formInputs,

        serviceProviderCode:
          selectedServiceExecutiveData?.userId || selectedSupplier,
        serviceProviderUserId:
          selectedServiceExecutiveData?.userId || selectedSupplier,
        serviceProviderName:
          selectedServiceExecutiveData?.firstName ||
          selectedServiceExecutiveData?.name ||
          "",

        shouldCollectMoney: shouldCollectMoney,

        //---Service Executive Assign Status
        erfStatus: "Under Service Executive",
        erfStatusCode: "USE",

        //---Service Executive Assign Timestamp
        assignDateAndTime: assignTimestamp,

        assignedServiceExecutives: updatedHistory,

        jobDoneStatus: "Pending",
        jobDoneRemarks: "",

        // Required Keys
        documentNumber: erfData.documentNumber,
        erfTypeCode: erfData.erfTypeCode,
        equipmentRentNr: erfData?.documentNumber,
        erfTypeDescription: erfData.erfTypeDescription,
      };

      delete payloadData.data;
      delete payloadData._id;

      await ItemService.updateEquipmentRentForm(payloadData);

      toast.success("Service Executive Assigned Successfully");

      onHide();
      onSuccess?.();
    } catch (err) {
      toast.error("Failed to assign Service Executive");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
      ref={ref}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Assign To Service Executive - {erfData?.documentNumber}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/*  Header Level Dispatch Details Block */}
        <div className="accordion" id="accordionDispatchDetails">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isDispatchVisible ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={() => toggleCardVisibility1(!isDispatchVisible)}
                  ></i>
                </Col>
                <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                  <span className="iconLogo">AD</span>
                </Col>
                <Col xs={12} md={8} lg={8}>
                  <span className="headerTitle">
                    Assign To Service Executive Details
                  </span>
                  <span className="subHeaderTitle">
                    Service Executive & Address Information
                  </span>
                </Col>
                <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                  {/* buttons if needed */}
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isDispatchVisible ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="">
                  <Row>
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label="Assignment Category"
                        name="serviceAssignCategory"
                        code="serviceAssignCategoryCode"
                        description="serviceAssignCategoryDesc"
                        data={serviceAssignentCategoryOption}
                        id="serviceAssignCategory"
                        iconClassName="dropdownIcon"
                        setValue={formInputs?.serviceAssignCategory}
                        error={validation?.serviceAssignCategory}
                        getvalue={setDropdownData}
                        required={true}
                      />
                    </Col>

                    <Col xs={12} className="commTopButtonRightLeftPadding">
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="shouldCollectMoney"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                          checked={shouldCollectMoney}
                          onChange={(e) =>
                            setShouldCollectMoney(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label fw-bold mt-1"
                          htmlFor="shouldCollectMoney"
                          style={{ cursor: "pointer" }}
                        >
                          Requires Payment Collection
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={4}
                      md={6}
                      xs={12}
                      className="commTopButtonRightLeftPadding"
                    >
                      <label className="form-label">Service Executive</label>

                      <select
                        className="form-control inputBox"
                        value={selectedSupplier}
                        onChange={handleSupplierChange}
                      >
                        <option value="">Select Service Executive</option>

                        {mrUserData?.data?.map((item) => (
                          <option key={item.userId} value={item.userId}>
                            {item.name}{" "}
                            {/* "SEREX01-Akash Singh" — full display name */}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <Col
                      lg={4}
                      md={6}
                      xs={12}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        label="Service Executive Code"
                        className="inputBox"
                        name="serviceExecutiveCode"
                        value={selectedServiceExecutiveData?.userId || ""}
                        disabled
                      />
                    </Col>

                    <Col
                      lg={4}
                      md={6}
                      xs={12}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        label="Service Executive Name"
                        className="inputBox"
                        name="serviceExecutiveName"
                        value={selectedServiceExecutiveData?.firstName || ""}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={12}
                      md={8}
                      lg={8}
                      className="commTopButtonRightLeftPadding"
                    >
                      <TextAreaField
                        label="Service Description"
                        className="inputBox"
                        name="serviceAssignCategoryDescription"
                        value={
                          formInputs?.serviceAssignCategoryDescription || ""
                        }
                        onChange={handleInputChange}
                        required={true}
                      />
                    </Col>
                  </Row>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* DataTable */}
        {/* <Row>
          <Col lg={12}>
            <DataTable columns={columns} data={rentItems} pagination />
          </Col>
        </Row> */}

        {/* Action Buttons */}
        <Row className="mt-4">
          <Col xs={12} md={4} lg={4} className="headerButtonAlign">
            {/* <Col className="d-flex justify-content-start"> */}
            <Col
              xs={4}
              md={2}
              lg={2}
              className="d-flex justify-content-between"
            >
              <button className="btnTable btn-danger" onClick={onHide}>
                Cancel
              </button>
            </Col>
            <Col
              xs={4}
              md={2}
              lg={2}
              className="d-flex justify-content-between"
            >
              {/* <button className="btnTable btn-danger me-2" onClick={onHide}>
              Cancel
            </button> */}
              <button className="btnTable" onClick={handleUpdate}>
                Assign Service Executive
              </button>
            </Col>
          </Col>
        </Row>

        {/* ── Assignment History ─────────────────────────────────── */}
        {erfData?.assignedServiceExecutives?.length > 0 && (
          <div className="accordion mt-4" id="accordionAssignHistory">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isServiceExecutiveHistoryVisible
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                      }`}
                      onClick={() =>
                        toggleCardVisibility2(!isServiceExecutiveHistoryVisible)
                      }
                    ></i>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">AH</span>
                  </Col>

                  <Col xs={8} md={8} lg={8}>
                    <span className="headerTitle">
                      Service Executive Assignment History
                    </span>
                    <span className="subHeaderTitle">
                      Previously assigned service executives
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isServiceExecutiveHistoryVisible ? "visible" : ""
                }`}
              >
                <div className="accordion-body p-0">
                  <DataTable
                    columns={assignmentHistoryColumns}
                    data={[...erfData.assignedServiceExecutives].reverse()} // latest first
                    pagination
                    // paginationRowsPerPageOptions={[5, 10, 20]}
                    noDataComponent={
                      <div className="p-3 text-muted text-center">
                        No assignment history found
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      {/* <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      /> */}
      {/* <EwayBillModal
  show={showEwayForm}
  onHide={handleCloseEwayForm}
  erfData={erfData}
/> */}
    </Modal>
  );
});

export default AssignToDispatchModel;
